// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

import { encodeWhitespace } from "../_common/to_file_url.ts";
import { isAbsolute } from "./is_absolute.ts";

/**
 * Converts a path string to a file URL.
 *
 * @example Usage
 * ```ts
 * import { toFileUrl } from "@std/path/posix/to-file-url";
 * import { assertEquals } from "@std/assert";
 *
 * assertEquals(toFileUrl("/home/foo"), new URL("file:///home/foo"));
 * assertEquals(toFileUrl("/home/foo bar"), new URL("file:///home/foo%20bar"));
 * ```
 *
 * @param path The path to convert.
 * @returns The file URL.
 */
export function toFileUrl(path: string): URL {
  if (!isAbsolute(path)) {
    throw new TypeError(`Path must be absolute: received "${path}"`);
  }

  const url = new URL("file:///");
  url.pathname = encodeWhitespace(
    path.replace(/%/g, "%25").replace(/\\/g, "%5C"),
  );
  return url;
}

// denoCacheMetadata={"headers":{"x-goog-storage-class":"STANDARD","etag":"\"99e7fc32c1a8e243fc0c49ed9c77707e\"","x-jsr-cache-status":"hit","x-guploader-uploadid":"AHmUCY0VayyUZHgkAj9aoE9BBqBmblqZdfnoUedjeKEmYgqIFu-RIuBO5qCFVth283GrlOu1mu8","via":"1.1 google","x-goog-stored-content-length":"928","last-modified":"Fri, 01 Nov 2024 10:38:02 GMT","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","access-control-allow-origin":"*","x-goog-generation":"1730457482870779","x-jsr-cache-id":"IAD","cross-origin-resource-policy":"cross-origin","x-content-type-options":"nosniff","x-goog-metageneration":"1","cache-control":"public, max-age=31536000, immutable","server":"UploadServer","age":"2329","x-goog-stored-content-encoding":"identity","accept-ranges":"bytes","expires":"Sat, 08 Nov 2025 09:31:12 GMT","content-length":"928","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","date":"Fri, 08 Nov 2024 09:31:12 GMT","x-robots-tag":"noindex","x-goog-hash":"crc32c=iVRGOw==,md5=mef8MsGo4kP8DEntnHdwfg==","access-control-expose-headers":"*","content-type":"text/typescript"},"url":"https://jsr.io/@std/path/1.0.8/posix/to_file_url.ts","time":1731060601}